export const SET_WEEKDAYS = ({ commit }, data) => {
  commit("SET_WEEKDAYS", { data: data });
};

export const SET_TOAST = ({ commit }, data) => {
  commit("SET_TOAST", { data: data });
};

export const SET_DATETIME = ({ commit }, data) => {
  commit("SET_DATETIME", { data: data });
};

export const UPDATE_DATE = ({ commit }, data) => {
  commit("UPDATE_DATE", { data: data });
};

export const UPDATE_TIME = ({ commit }, data) => {
  commit("UPDATE_TIME", { data: data });
};

export const TOGGLE_FILTER_BUTTON = ({ commit }) => {
  commit("TOGGLE_FILTER_BUTTON");
};

export const SET_MAP_BOUNDS = ({ commit }, data) => {
  commit("SET_MAP_BOUNDS", { data: data });
};

export const SET_GEOJSON = ({ commit }, data) => {
  commit("SET_GEOJSON", { data: data });
};

export const SET_API_CALL_URL = ({ commit }, data) => {
  commit("SET_API_CALL_URL", { data: data });
};

export const SET_MEASUREMENT = ({ commit }, data) => {
  commit("SET_MEASUREMENT", { data: data });
};

export const SET_CHOROPLETH_VISIBILITY = ({ commit }, data) => {
  commit("SET_CHOROPLETH_VISIBILITY", { data: data });
};

export const SHOW_MARKER = ({ commit }) => {
  commit("SHOW_MARKER");
};

export const SET_MARKER_POSITION = ({ commit }, data) => {
  commit("SET_MARKER_POSITION", { data: data });
};

export const SET_MAP_CENTER = ({ commit }, data) => {
  commit("SET_MAP_CENTER", { data: data });
};

export const SET_POINTS = ({ commit }, data) => {
  commit("SET_POINTS", { data: data });
};

export const TOGGLE_HEATMAP = ({ commit }) => {
  commit("TOGGLE_HEATMAP");
};

export const REFRESH_HEATMAP = ({ commit }) => {
  commit("REFRESH_HEATMAP");
};

export const TOGGLE_DRAWER = ({ commit }) => {
  commit("TOGGLE_DRAWER");
};

export const TOGGLE_FILTER_DIALOG = ({ commit }) => {
  commit("TOGGLE_FILTER_DIALOG");
};

export const SET_HEATMAP_VISIBLE_POINTS = ({ commit }, data) => {
  commit("SET_HEATMAP_VISIBLE_POINTS", { data: data });
};

export const ADD_MARKER = ({ commit }, data) => {
  commit("ADD_MARKER", { data: data });
};

export const INCREMENT_MARKER_ID = ({ commit }, data) => {
  commit("INCREMENT_MARKER_ID", { data: data });
};

export const SET_MARKER_ID = ({ commit }, data) => {
  commit("SET_MARKER_ID", { data: data });
};

export const TOGGLE_REVIEW_DIALOG = ({ commit }) => {
  commit("TOGGLE_REVIEW_DIALOG");
};

export const TOGGLE_BARRIER_ACTIVE_STATE = ({ commit }, data) => {
  commit("TOGGLE_BARRIER_ACTIVE_STATE", { data: data });
};

export const SET_BARRIERS = ({ commit }, data) => {
  commit("SET_BARRIERS", { data: data });
};

export const SET_BUDGET = ({ commit }, data) => {
  commit("SET_BUDGET", { data: data });
};
